import type { DirectoryPublic } from '@repo/types/directory';
import type { FilePublicWithPermissions } from '@repo/types/files';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import { axiosInstance } from '#api-client';

export class FileSystemService {
  static async searchFileSystem(name: string): Promise<AxiosResponse<FileSystemItems>> {
    return await axiosInstance.get('/api/fs/search', {
      params: { name: name },
    });
  }

  static async getShared(): Promise<AxiosResponse<FileSystemItems>> {
    return await axiosInstance.get('/api/fs/getShared');
  }

  static async downloadFsItems(data: FileSystemItemsDownloadPayload, options?: AxiosRequestConfig<FileSystemItemsDownloadPayload>): Promise<AxiosResponse<Blob>> {
    const { onDownloadProgress, signal } = options || {};

    return await axiosInstance.post('/api/fs/download', data, {
      responseType: 'blob',
      onDownloadProgress,
      signal,
    });
  }
}

export interface FileSystemItems {
  files: FilePublicWithPermissions[];
  dirs: DirectoryPublic[];
}

export interface FileSystemItemsDownloadPayload {
  fileIds: string[];
  dirIds: string[];
}
